import { history } from 'umi';
import { getUrlParam, isBrowser } from '@/utils/utils';

const wx = require('weixin-js-sdk');

export function getBridge() {
  // @ts-ignore
  return window.bridgeAndroid || window.bridgeIOS;
}

// @ts-ignore
window.setTokenWithoutFresh = setTokenWithoutFresh;
// @ts-ignore
window.setTokenWithFresh = setTokenWithFresh;

// app调用方法 不刷新
function setTokenWithoutFresh(item: any, _this: string = 'app') {
  console.log('调用setTokenWithoutFresh', _this);
  localStorage.setItem('token', item);
  return item;
}

// app调用方法
function setTokenWithFresh(item: any, _this: string) {
  localStorage.setItem('token', item);
  location.reload();
}

/**
 * 关闭当前所在native的activity
 */
export function goBack() {
  const bridge = getBridge();
  if (bridge) {
    if (!history.location.state) {
      bridge.goBack();
    } else {
      history.goBack();
    }
    return;
  }

  isMiniPrograms().then(() => {
    if (!history.location.state) {
      wx.miniProgram.navigateBack();
    }
    return;
  });

  history.goBack();
}

export function Close() {
  const bridge = getBridge();
  if (bridge) {
    bridge.goBack();
  }
}

//分享
export function getShare(params: any) {
  const bridge = getBridge();
  if (bridge) {
    bridge.share(JSON.stringify(params));
  }
}

//登录
export function getLogin() {
  const bridge = getBridge();
  if (bridge) {
    if (bridge.appLogin) {
      bridge.appLogin();
    }
  }
  isMiniPrograms().then(() => {
    localStorage.removeItem('token');
    wx.miniProgram.navigateTo({
      url: '/pages/login/login',
    });
  });
}

/**
 * 获取token
 */
export function getToken(fresh: boolean = true) {
  const bridge = getBridge();
  if (bridge) {
    if (bridge.getToken) {
      // @ts-ignore
      if (window.bridgeIOS) {
        console.log('调用getToken');
        bridge.getToken('', (item: string) => {
          token(item, fresh);
        });
        return;
      }
      const data = bridge.getToken();
      token(data, fresh);
    }
  }

  isMiniPrograms().then(() => {
    setTimeout(() => {
      let data = getUrlParam('access_token');
      let token = localStorage.getItem('token');
      if (data) {
        localStorage.setItem('token', data);
      } else {
        if (!token) {
          getLogin();
        }
      }
    });
  });
}

//相机
export function getCamera(type?: string) {
  const bridge = getBridge();
  if (bridge) {
    if (bridge.camera) {
      bridge.camera(type || 'one', function (item: any) {
        if (item) {
          // var cc=new Image();
          // cc.src= item;
          // document.getElementById("root").appendChild(cc);
          return item;
        }
      });
      return;
    }
  }
}

//routes
export function getRoutes(jumpType: string, params: object) {
  const bridge = getBridge();
  if (bridge) {
    if (bridge.router) {
      const url = `qiangfen://www.qiangfen.com?jump_type=${jumpType}&params=${encodeURIComponent(
        JSON.stringify(params),
      )}`;
      bridge.router(url);
    }
  }
}

export function token(data: any, fresh: boolean = true) {
  if (data && data !== '') {
    fresh ? setTokenWithFresh(data, 'js') : setTokenWithoutFresh(data, 'js');
    return;
  }
  getLogin();
}

//是否显示隐藏hideTabBar
export function hideTabBar(boolean = false) {
  const bridge = getBridge();
  if (bridge) {
    if (bridge.hideTabBar) {
      bridge.hideTabBar(boolean);
    }
  }
}

// 判断是否是小程序端
export function isMiniPrograms() {
  // 判断是否是小程序打开
  return new Promise((resolve, reject) => {
    if (isBrowser() === 'weixin') {
      wx.miniProgram.getEnv((res: { miniprogram: any }) => {
        if (res.miniprogram) {
          //在小程序中
          resolve(res.miniprogram);
        } else {
          // 在微信网页
          reject(false);
        }
      });
    } else {
      reject(false);
    }
  }).catch((error) => {
    return false;
  });
}
